import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  Autocomplete,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import toast from "react-hot-toast";
import ImageWrapper from "../ImageComponent/ImageWrapper";

const mapContainerStyle = {
  height: "100%", // Adjusting height to leave space for the footer
  width: "100%",
};

const center = {
  lat: 12.97927,
  lng: 77.653038,
};

const GoogleMapsComponent = ({
  editAddressModalData,
  closeAddressModal,
  onGMapsContinue,
}) => {
  const [mapCenter, setMapCenter] = useState(center);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [address, setAddress] = useState("");
  const autocompleteRef = useRef(null);
  const [autocompleteLoaded, setAutocompleteLoaded] = useState(false);
  const [placeAddress, setPlaceAddress] = useState(null);
  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    setPlaceAddress(place);
    if (place.geometry) {
      const position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      setMapCenter(position);
      setMarkerPosition(position);
      setAddress(place.formatted_address);
    }
  };
  // WIll be taken care when We need to edit the coordinates
  useEffect(() => {
    if (editAddressModalData && Object.keys(editAddressModalData).length > 0) {
      const position = {
        lat: editAddressModalData.coordinates?.lat,
        lng: editAddressModalData.coordinates?.lng,
      };
      setMapCenter(position);
      setMarkerPosition(position);
      setAddress(
        `${editAddressModalData.areaLocation}, ${editAddressModalData.landmark}, ${editAddressModalData.city}, ${editAddressModalData.state}, ${editAddressModalData.pincode}`
      );
    }
  }, [editAddressModalData]);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setMapCenter(currentPosition);
          setMarkerPosition(currentPosition);
          fetchAddress(currentPosition);
        },
        (error) => {
          toast.error("Error getting current location: ", error);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const handleMapClick = (event) => {
    const position = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
    setMarkerPosition(position);
    fetchAddress(position);
  };

  const fetchAddress = async (position) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: position }, (results, status) => {
      if (status === "OK" && results[0]) {
        setPlaceAddress(results[0]);
        setAddress(results[0].formatted_address);
      } else {
        console.error("Geocoder failed due to: " + status);
      }
    });
  };

  const handleContinue = () => {
    if (markerPosition) {
      onGMapsContinue(markerPosition, placeAddress);
    } else {
      toast.error("Please select a location on the map");
    }
  };

  useEffect(() => {
    if (autocompleteLoaded) {
      const currentLocationOption = document.createElement("div");
      currentLocationOption.classList.add("pac-item");
      currentLocationOption.textContent = "Current Location";
      currentLocationOption.addEventListener("click", getCurrentLocation);

      const pacContainer = document.querySelector(".pac-container");
      if (pacContainer) {
        pacContainer.insertBefore(
          currentLocationOption,
          pacContainer.firstChild
        );
      }
    }
  }, [autocompleteLoaded]);
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GOOGLE_API_KEY,
    libraries: ["maps", "places"], // Include both libraries if needed
  });
  return (
    <>
      {isLoaded && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center z-50 justify-center bg-ModalTransparentColor">
          <div className="flex flex-col justify-between bg-white w-full h-full md:w-3/6 lg:w-2/5 xl:w-1/3 md:h-[85vh] md:rounded-lg">
            <header className="flex justify-between items-center border-b p-4">
              <div className="flex items-center gap-2">
                <h3 className="font-semibold">Select Puja Location</h3>
              </div>
              <button className="w-4 h-4" onClick={closeAddressModal}>
                <ImageWrapper
                  src="/icons/Cancelbutton.svg"
                  alt="CancelButton"
                />
              </button>
            </header>
            <main className="h-full flex flex-col justify-start">
              <div className="relative" style={{ height: "calc(100% - 60px)" }}>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={mapCenter}
                  zoom={10}
                  onClick={handleMapClick}
                >
                  <Autocomplete
                    onLoad={(autocomplete) =>
                      (autocompleteRef.current = autocomplete)
                    }
                    onPlaceChanged={onPlaceChanged}
                  >
                    <input
                      type="text"
                      placeholder="Search for places"
                      className="absolute top-2 left-2 w-3/4 h-10 p-2 z-10 bg-white"
                      style={{ zIndex: 10 }}
                    />
                  </Autocomplete>
                  {markerPosition && <Marker position={markerPosition} />}
                </GoogleMap>
              </div>
              {address && (
                <div className="p-4 text-s">
                  <p>{address}</p>
                </div>
              )}
            </main>
            <footer className="p-4 border-t">
              <button
                className="border border-BluntRed bg-BluntRed text-white hover:bg-HoverModalButtonColor rounded-lg w-full text-sm font-medium py-3.5"
                onClick={handleContinue}
              >
                Continue
              </button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default GoogleMapsComponent;
